<!--
 * @Author: xuesong
 * @Date: 2021-04-26 13:39:30
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-12 18:22:43
 * @Description: 7 完善健康档案
-->
<template>
<div class="custom-7" :style="{backgroundColor: bgColor,color: color}">

  <div class="info-content" >
    <!-- <img
          src="https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3155998395,3600507640&fm=26&gp=0.jpg"
          alt=""
        /> -->
        <img
          src="../../static/IM/eighteen-msg.png"
          alt=""
        />
    <div class="seytm_text">
       {{ data.name }}
    </div>
               

            </div>
</div>

</template>

<script>
export default {
props:{
    data:{
      type: Object,
      default: ()=>{}
    },
     bgColor:{
      type: String,
      default: '#F5F5F5'
    },
    color:{
      type: String,
      default: '#333'
    }
  }
}
</script>

<style lang="less" scoped>
.custom-7{
  border-radius: 4px;    
 .info-content {
        display: flex;
        align-items: center;
        word-break: break-all;
        
        padding:10px;
        font-size: 12px;
        font-weight: 500;

        text-align: left;
        display: flex;
         img {
          height: 60px;
          width: 60px;
          margin-right: 15px;
        }
        
      }
}

</style>